import * as React from 'react'
import { Prompt } from 'react-router-dom'

const confirmFunction = location => (location.hash === '' ? 'Are you sure you want to leave this page?' : undefined)

const NavigationPrompt = ({ when }) => <Prompt when={when} message={confirmFunction} />

export default NavigationPrompt
